var React = require('react');

function FooterCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2302.89 220C2302.96 219.002 2303 218.002 2303 217C2303 97.1542 1787.46 0 1151.5 0C515.544 0 0 97.1542 0 217C0 218.002 0.0360107 219.002 0.107788 220H2302.89Z","fill":"white"}));
}

FooterCircle.defaultProps = {"viewBox":"0 0 2303 220"};

module.exports = FooterCircle;

FooterCircle.default = FooterCircle;
